import { DataFieldGroup } from '@models/settings/data-field-group.model';
import { DataField } from '@models/settings/data-field.model';

export const getDataFieldGroupByName = (
    name: string,
    dataFields: DataField[] | null,
    isDefault = false
): DataFieldGroup | null => {
    if (!dataFields) {
        return null;
    }

    if (isDefault) {
        return (
            dataFields.find(function (df: DataField) {
                return df.dataFieldGroup.name === name && df.dataFieldGroup.isDefault === isDefault;
            })?.dataFieldGroup ?? null
        );
    }

    return dataFields.find((df: DataField) => df.dataFieldGroup.name === name)?.dataFieldGroup ?? null;
};
